import {
    ParticipationView,
    viewIncludesCarbon,
    viewIncludesCommunityEvents,
    viewIncludesCommunityTreeDistributor,
    viewIncludesReforestation,
    viewIncludesMembershipTrees
} from './ParticipationViewSelector';
import CarbonParticipationHeader from './ProjectTypeTables/CarbonTable/CarbonParticipationTableHeader';
import {CommunityEventHeader} from './ProjectTypeTables/CommunityEventTable/CommunityEventHeader';
import {CommunityTreeDistributorParticipationHeader} from './ProjectTypeTables/CommunityTreeDistributorTable/CommunityTreeDistributorParticipationHeader';
import {MembershipTreesHeader} from './ProjectTypeTables/MembershipTreesTable/MembershipTreesHeader';
import {ReforestationHeader} from './ProjectTypeTables/ReforestationTable/ReforestationHeader';

function ParticipationColumnHeaderRow({view}: {view: ParticipationView}) {
    if (viewIncludesReforestation(view)) return <ReforestationHeader />;

    if (viewIncludesCommunityEvents(view)) return <CommunityEventHeader />;

    if (viewIncludesCommunityTreeDistributor(view))
        return <CommunityTreeDistributorParticipationHeader />;

    if (viewIncludesCarbon(view)) {
        return <CarbonParticipationHeader />;
    }
    if (viewIncludesMembershipTrees(view)) {
        return <MembershipTreesHeader />;
    }
}

export default ParticipationColumnHeaderRow;
